import React from 'react'
import "./Home.css"
import { Hero, Services } from '../../Features/Home'

const Home = ({ url,data,language,translations}) => {


  return (
    <div className='home-services'>
        <Hero url={url} data={data} language={language} />
        <Services url={url} data={data}  language={language} translations={translations}/>
    </div>
  )
}

export default Home